import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    initializeBlock = function() {

        // sliders
        var splideElements = document.querySelectorAll('.breast__slider.splide');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                var options = JSON.parse(splideElement.getAttribute('data-splide'));
                var splide = new Splide(splideElement, options);
                splide.mount();
            });
        }
    }
    
    if( window.acf ) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction( 'render_block_preview/type=reviews-slider', initializeBlock );
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
});